
import i18n from 'i18next';
//import Backend from 'i18next-fs-backend';
import { reactI18nextModule } from "react-i18next";
import en from './en/translations.json'
import hr from './hr/translations.json'

// the translations
const resources = {
  en: {
    translation: en
  },
  hr: {
    translation: hr
  }
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "hr",

   // keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
});

export default i18n;